import { Undo2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const money = (value) => (Number.parseFloat(value) || 0).toLocaleString("en-AU", { style: "currency", currency: "AUD" });
const when = (iso) => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleString("en-AU", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });
};

// Lines someone deleted (or, for an emailed item, dismissed) that match the search, listed
// under the results. They are hidden everywhere else, so without this a fee slip deleted by
// mistake could not be found again (26 Oct 2026). They are not counted in any total; Restore
// puts one back in the list.
export default function DismissedMatches({ rows, onRestore, restoringId }) {
  if (!rows.length) return null;
  return (
    <section className="border-t-4 border-slate-100" aria-label="Deleted lines matching the search">
      <div className="flex items-center justify-between gap-3 bg-rose-50 px-4 py-2">
        <span className="text-[10px] font-bold uppercase tracking-wide text-rose-800">
          Deleted — not counted ({rows.length})
        </span>
        <span className="text-[10px] text-rose-700">Restore one to put it back in its list.</span>
      </div>
      <ul className="divide-y divide-slate-100">
        {rows.map((row) => (
          <li key={row.id} className="flex flex-wrap items-center justify-between gap-2 px-4 py-2.5">
            <div className="min-w-0 space-y-0.5">
              <p className="text-xs font-semibold text-slate-700">
                {row.clientName} · {money(row.invoiceAmount)}
                <span className="ml-2 rounded border border-rose-200 bg-rose-50 px-1.5 py-0.5 text-[9px] font-bold uppercase text-rose-700">
                  Deleted
                </span>
              </p>
              <p className="truncate text-[10px] text-slate-500">
                {[row.clerkName, row.invoiceRef ? `Invoice ${row.invoiceRef}` : row.invoiceName].filter(Boolean).join(" · ")}
                {row.dismissedBy ? ` · deleted by ${row.dismissedBy}` : ""}
                {row.dismissedAt ? ` ${when(row.dismissedAt)}` : ""}
              </p>
            </div>
            <Button
              type="button"
              variant="outline"
              onClick={() => onRestore(row)}
              disabled={restoringId === row.id}
              className="h-7 gap-1 px-2 text-[11px]"
            >
              <Undo2 className="h-3.5 w-3.5" /> {restoringId === row.id ? "Restoring…" : "Restore"}
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
}
